import { faTablePivot } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ViewFieldsFragment } from '@salescore/client-api'
import { CONSTANT } from '@salescore/client-base'
import { useCanForView } from '@salescore/client-common'
import type { ViewUiKpiPivot } from '@salescore/core'
import { ButtonWithTooltip } from '@salescore/frontend-common'
import { App, Button, Row, Space } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'

import type { RSheetColumn, RSheetRecordNode } from '../../../domain/column'
import { Section } from '../Section'
import { DimensionsPicker } from './DimensionsPicker'
import { buildKpiPivotKpisFormModalProperties } from './KpiPivotKpisFormModal'

export const KpiPivotParameterSider = ({
  component,
  close,
  columns,
  view,
  setHasChangeToViewSchema,
}: {
  component: ViewUiKpiPivot
  close?: () => void
  columns: Array<RSheetColumn<RSheetRecordNode>>
  view: ViewFieldsFragment
  setHasChangeToViewSchema: (hasChangeToViewSchema: boolean) => void
}): ReactElement => {
  const { modal } = App.useApp()
  const canUpdate = useCanForView('update', view)

  return (
    <div className="h-full overflow-y-auto bg-white p-4" style={{ borderRight: `1px solid ${CONSTANT.colors.border}` }}>
      <Row justify="space-between">
        <Space className="mb-3 text-lg font-bold">
          <FontAwesomeIcon icon={faTablePivot} />
          {t(`集計設定`)}
        </Space>
        {close !== undefined && (
          <Space>
            <Button
              onClick={() => {
                close()
              }}
              type="text"
            >
              {t(`閉じる`)}
            </Button>
          </Space>
        )}
      </Row>
      <KpiPivotDimensionPickerWrapper component={component} />
      <Section title={t(`KPIグループ設定`)} description={t(`KPIの追加、削除、並び替え、グルーピング`)}>
        <ButtonWithTooltip
          disabled={!canUpdate}
          showTooltip={!canUpdate}
          tooltipTitle={t(`権限がないため編集できません`)}
          onClick={() => {
            const m = modal.confirm(
              buildKpiPivotKpisFormModalProperties({
                onFinish: () => {
                  m.destroy()
                },
                columns,
                view,
                setHasChangeToViewSchema,
              }),
            )
          }}
        >
          {t(`設定画面を開く`)}
        </ButtonWithTooltip>
      </Section>
    </div>
  )
}

const KpiPivotDimensionPickerWrapper = ({ component }: { component: ViewUiKpiPivot }): ReactElement => (
  // 行列を選ばせる基本的なUI
  <>
    <Section title={t(`集計項目 - 行`)} description={t(`集計したい項目をクリックしてください。並び替えもできます。`)}>
      <DimensionsPicker dimensions={component.dimensions} type={'rows'} />
    </Section>
    <Section title={t(`集計項目 - 列`)} description={t(`集計したい項目をクリックしてください。並び替えもできます。`)}>
      <DimensionsPicker dimensions={component.dimensions} type={'columns'} />
    </Section>
  </>
)
